import { apiRequest } from "../../index";

export const getRestaurantById = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/${restaurantId}`, "GET");
};

export const getRestaurantMenu = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/menu/${restaurantId}`, "GET");
};

export const getAllCategories = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/menu/category/${restaurantId}`, "GET");
};

export const getRestaurantSlots = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/slots/${restaurantId}`, "GET");
};


//  Table Bookings

export const bookTable = async (data) => {
  return apiRequest(`/api/user/restaurants/table-reserve`, "POST" , data);
};

export const getOngoingTableRequest = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/ongoing/reservation/${restaurantId}`, "GET");
};

export const getAllTableBookings = async ({page , limit=10 , restaurantId}) => {
  return apiRequest(`/api/user/restaurants/table/bookings/${restaurantId}?page=${page}&limit=${limit}`, "GET");
};

export const getReservationDetail = async (reservationId) => {
  return apiRequest(`/api/user/restaurants/table/booking/${reservationId}`, "GET");
};

export const TableCheckout = async ({reservationId}) => {
  return apiRequest(`/api/user/restaurants/table-reserve/checkout/${reservationId}`, "GET");
};

export const verifyTableCode = async (data) => {
  return apiRequest(`/api/user/restaurants/verify/table-code`, "POST" , data);
};

export const reviewAdd = async (data) => {
  return apiRequest(`/api/common/reviews`, "POST" , data);
};

// Orders

export const getCartPrice = async ({reservationId, restaurantId , items , offerId}) => {
  return apiRequest(`/api/user/restaurants/cart/price`, "POST" , { orderData : {reservationId ,restaurantId , items , offerId}});
};

export const placeOrder = async({reservationId , items , notes , offerId , tableNumber , deliveryType , deliveryAddress})=>{
  return apiRequest(`/api/user/restaurants/order/food`, "POST" , { orderData : {reservationId , items , notes , offerId , tableNumber , deliveryType , deliveryAddress}});
}

export const getOrderDetail = async(orderId)=>{
  return apiRequest(`/api/user/restaurants/order/detail/${orderId}`, "GET" );
}

export const requestWaiter = async(data)=>{
  return apiRequest(`/api/user/restaurants/request/waiter`, "POST" ,data );
}

export const getWaiterRequest = async(reservationId)=>{
  return apiRequest(`/api/user/restaurants/request/waiter/${reservationId}`, "GET" );
}

export const getAllOrders = async (restaurantId) => {
  return apiRequest(`/api/user/restaurants/orders/all/${restaurantId}`, "GET");
};

export const getAvailableOffers = async ({ hotelId, restaurantId }) => {
  const params = new URLSearchParams();

  if (restaurantId) params.append("restaurantId", restaurantId);
  if (hotelId) params.append("hotelId", hotelId);

  return apiRequest(`/api/user/restaurants/available/offers?${params.toString()}`, "GET");
};


export const getRestaurantReviews = async ({ page = 1, restaurantId }) => {
  return apiRequest(
    `/api/common/reviews?page=${page}&limit=10&restaurantId=${restaurantId}`, "GET"
  );
  
};